import merge from 'lodash/merge'
import txGroupTheme from 'theme/shared/themes/txgroup'
import {BRANDS} from 'const'
import {getFavicon, getHeaderLogo, getFooterLogosByBrandList} from '../commonHelper'
import {getLang} from 'utils/stringUtils'

const isGerman = (getLang(window.location.search) || 'de') === 'de'

const brand = BRANDS.tamedia
const brandUrl = `https://www.tamedia.ch/${isGerman ? 'de' : 'fr'}`
const germanLogos = [BRANDS.baz, BRANDS.tagesanzeiger, BRANDS.bernerzeitung, BRANDS.sonntagszeitung]
const frenchLogos = [BRANDS.tribunedegeneve, BRANDS.twentyfourhours, BRANDS.bilan, BRANDS.lematindimanche]

const otherBrandsLogos = getFooterLogosByBrandList(isGerman ? germanLogos : frenchLogos)

export default merge({}, txGroupTheme, {
  brand: {
    name: brand,
    url: brandUrl,
    favicon: getFavicon(brand),
  },
  shell: {
    header: {
      logo: {
        height: {
          default: '44px',
          small: '32px',
          onScroll: '32px',
        },
        src: {
          default: getHeaderLogo(brand),
        },
      },
    },
  },
  otherBrandsLogos,
})
